:host {
  --search-input-height: 54px;
}

.list {
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100%;

  &--search {
    padding: calc(1.5 * var(--spacer)) var(--spacer);
  }

  &--title {
    padding: var(--spacer);
  }

  &--error {
    padding: calc(var(--spacer) * 2) calc(var(--spacer) / 2 - 2px);
    line-height: 1.5;
    color: var(--chart-302-icon-buttons-titles);
  }

  &--options {
    padding: 0 var(--spacer);
    flex: 1;
    overflow: auto;
    max-height: var(--gz-enum-max-height, none);

    .option {
      &.hidden {
        display: none;
      }
      gz-text {
        color: var(--main-titles-inputs-600);
      }
    }
  }

  &--no-results {
    text-align: center;
    display: none;
    padding: calc(var(--spacer) * 2) 0;

    &.visible {
      display: block;
      color: var(--chart-302-icon-buttons-titles);
    }
  }
}

:host(.enum-filter-list) {
  .list {
    max-height: var(--enum-filter-content-max-height);

    &--search {
      display: none;
      position: absolute;
      width: 100%;
      height: var(--search-input-height);
      top: 0;
    }

    &.has-search {
      padding-top: var(--search-input-height);

      .list {
        &--search {
          display: block;
        }
      }
    }
  }
}

:host(.hidden-search-input) {
  .list {
    max-height: var(--enum-filter-content-max-height);

    &--search {
      display: none;
      position: absolute;
      width: 100%;
      height: var(--search-input-height);
      top: 0;
    }
  }
}

.checkbox-label {
  display: inline;
  vertical-align: middle;
}

gz-tooltip {
  display: block;
}

gz-text {
  display: inline;
  --font-family: var(--font-family-secondary);
}

.loading-container {
  height: 256px;

  gz-progress-spinner {
    height: 100%;
  }
}

.icon {
  padding-right: var(--spacer);
}

.icon {
  color: var(--chart-302-icon-buttons-titles);
}

.label {
  b {
    color: var(--main-titles-inputs-600);
  }
}
